import { render, staticRenderFns } from "./PolizasSAImportView.vue?vue&type=template&id=57224b26&"
import script from "./PolizasSAImportView.vue?vue&type=script&lang=js&"
export * from "./PolizasSAImportView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports